import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class OrigemProdutoService extends ServiceBase {

    title = "Origem do produto"
    pluralTitle = "Origem do produtos"
    url = '/cadastro/produto/origemproduto'
    frontUrl = '/cadastro/produto/origemproduto'
    frontUrlList = '/cadastro/produto/origemprodutolist'
    primaryKey = 'codigo_orip'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.ativo_orip = boolToNumber(data.ativo_orip, true)

        return data
    }

    prepareToSave({ data }) {

        data.ativo_orip = boolToNumber(data.ativo_orip)

        delete data.meta

        return data

    }

}
